import { SET_PERMISSONS, SET_SUB_ADMIN_PERMISSONS, SET_SUB_ADMIN_TYPE } from "../../actions/types/types";

const initState = {
  permissions: {},
  subAdminPermissions: {},
  subAdminType: "",
  staffDashFilter: ""
};

const PermissionReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_PERMISSONS:
      return {
        ...state,
        permissions: action.payload.data
      };
    case SET_SUB_ADMIN_PERMISSONS
      :
      return {
        ...state,
        subAdminPermissions: action.payload.data
      };
    case SET_SUB_ADMIN_TYPE
      :
      return {
        ...state,
        subAdminType: action.payload.data
      };
    case "SET_STAFF_DASH_FILTER"

      :
      return {
        ...state,
        staffDashFilter: action.payload.data
      };
    default:
      return { ...state };
  }
};

export default PermissionReducer;
